import { render } from "./LabelsPieChart.vue?vue&type=template&id=3e1e0025&scoped=true"
import script from "./LabelsPieChart.vue?vue&type=script&lang=js"
export * from "./LabelsPieChart.vue?vue&type=script&lang=js"

import "./LabelsPieChart.vue?vue&type=style&index=0&id=3e1e0025&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e1e0025"]])

export default __exports__